<template>
    <div>
        <!-- <div class="row justify-content-center">
                <div class="col-12 col-ms-12 col-md-12 col-lg-12">
                    <div class="col-12 col-ms-12 col-md-12 col-lg-12 form-group">
                        <label>Fecha Real de Cobro *</label>
                            <v-date-picker
                            v-if="ctaporcobrar.Estatus=='NO'"
                            v-model="ctaporcobrar.FechaRealCobro"
                            :popover="{ 
                                placement: 'right',
                                visibility: 'click',
                                
                            }"
                        
                            :input-props='{
                                class:"form-control calendar",
                                style:"cursor:pointer;background-color:#F9F9F9",
                                readonly: true
                            
                            }'
                        /> 
                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.FechaRealCobro" :Mensaje="errorvalidacion.FechaRealCobro[0]"></Cvalidation></label>
                        <input v-if="ctaporcobrar.Estatus=='SI'" class="form-control" readonly v-model="FechaRealCobro">
                        
                        <br>
                        <label>No. Contrato</label>
                        <input readonly v-model="NumContrato" class="form-control" />
                        <br>
                        <label>Observaciones *</label>
                        <div v-if="ctaporcobrar.Estatus=='NO'">
                            <textarea v-model="ctaporcobrar.Observacion"  v-if="ctaporcobrar.Estatus=='NO'" placeholder=" Coloque sus Observaciones" class="form-control" cols="2" rows="3"></textarea>
                            <Cvalidation v-if="this.errorvalidacion.Observacion" :Mensaje="'Campo obligatorio'"></Cvalidation>
                        </div>
                        
                        <textarea v-model="ctaporcobrar.Observacion" v-if="ctaporcobrar.Estatus=='SI'" readonly placeholder="Coloque sus Observaciones" class="form-control" cols="2" rows="3"></textarea>
                        
                    </div>
                    
                </div>
        </div> -->
        <!--<pre>{{
            ctaporcobrar
            }}</pre>-->
		<div class="form-group row">
			<div class="col-lg-4">
				<label for="">Factura</label>
				<input type="text" class="form-control" readonly v-model="ctaporcobrar.Factura">
			</div>
			<div class="col-lg-4">
				<label for="">Monto Total</label>
				<vue-numeric :disabled="true" class="form-control " currency="$" separator="," :precision="2" v-model="ctaporcobrar.MontoTotal" placeholder="$0.00"></vue-numeric>
			</div>
			<div class="col-lg-4">
				<label for="">No. Contrato</label>
				<input type="text" class="form-control" readonly v-model="NumContrato">
			</div>
		</div>
		<div class="form-group row mt-4">
			<div class="col-lg-4">
				<label for="">Tipo Cobro *</label>
				<select :disabled="DisableSelect" @change="SetMonto" v-model="ctaporcobrar.TipoCobro" class="form-control">
					<option value="">-Tipo de Cobro-</option>
					<option value="1">Total</option>
					<option value="2">Parcial</option>
				</select>
				<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.TipoCobro" :Mensaje="errorvalidacion.TipoCobro[0]"></Cvalidation></label>
			</div>
			<div class="col-lg-4">
				<label for="">Monto *</label>
				<vue-numeric :disabled="DisableMonto" @input="ChangeRestante" class="form-control " currency="$" separator="," :precision="2" v-model="ctaporcobrar.Monto" placeholder="$0.00"></vue-numeric>
				<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Monto" :Mensaje="errorvalidacion.Monto[0]"></Cvalidation></label>
			</div>
			<div class="col-lg-4">
				<label for="">Pendiente Pago</label>
				<vue-numeric :disabled="true" class="form-control " currency="$" separator="," :precision="2" v-model="ctaporcobrar.Restante" placeholder="$0.00"></vue-numeric>
			</div>
		</div>
		<div class="form-group row">
			<div v-for="(item,index) in ctaporcobrar.Pagos" :key="index" class="col-lg-3" v-show="index==IndexFecha || ctaporcobrar.TipoCobro=='2'">
				<label for="">{{index==IndexFecha ? 'Pago '+(index+1)+' *' : 'Pago '+(index+1)}}</label>
				<v-date-picker
				:masks="{input:'DD-MM-YYYY'}"
						v-model="item.Fecha"
						:popover="{
							placement: 'bottom',
							visibility: 'click'
						}"
						:input-props="{
							class: 'form-control calendar',
							style: 'cursor:pointer',
							disabled: index!=IndexFecha
						}"
						:locale="'es-MX'"
					/>
			</div>
		</div>
		<div class="form-group row mt-4">
			<div class="col-lg-12">
				<label>Observaciones y Pagos Parciales *</label>
				<textarea v-model="ctaporcobrar.Observacion" placeholder=" Coloque sus Observaciones" class="form-control" cols="2" rows="3"></textarea>
				<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Observacion" :Mensaje="errorvalidacion.Observacion[0]"></Cvalidation></label>
			</div>
		</div>
	</div>
</template>

<script>
import Cbtnsave from '@/components/Cbtnsave.vue'
import Cvalidation from '@/components/Cvalidation.vue'

export default {
   name:'cuentasporcobrar',
    props:['poBtnSave'],
     components:{
        
        Cbtnsave,Cvalidation
    },
    data() {
        return {
            
            ListaFacturas:[],
            cobrar:{},
            ctaporcobrar:{
                
                IdCtaCobrar:0,
                IdFactura:0,
                IdServicio:0,
                NumContrato:'',
                Archivo:'',
                Estatus:'',
                FechaRealCobro:'',
				Factura:'',
				TipoCobro:'',
				MontoTotal:'',
				Monto:'',
				Restante:'',
				Pagos:[
					{Fecha:'',Monto:''},
					{Fecha:'',Monto:''},
					{Fecha:'',Monto:''},
					{Fecha:'',Monto:''}
				]
            },
            //IdContrato:0,
            NumContrato:'',
            FechaRealCobro:'',
            errorvalidacion:[],
			IndexFecha:0,
			RestanteOriginal:0,
			DisableMonto:false,
			DisableSelect:false
        }
    },
   
   methods: {
      
        Cobrado()
        { 
			let formData=new FormData();
			formData.set('IdCtaCobrar',this.ctaporcobrar.IdCtaCobrar);
			formData.set('TipoCobro',this.ctaporcobrar.TipoCobro);
			formData.set('Observacion',this.ctaporcobrar.Observacion);
			formData.set('Fecha',this.ctaporcobrar.Pagos[this.IndexFecha].Fecha.toISOString());
			formData.set('Monto',this.ctaporcobrar.Monto);
			formData.set('Restante',this.ctaporcobrar.Restante);
            this.poBtnSave.toast=0;
            this.poBtnSave.disableBtn=true;
                this.$http.post(
                'ctaporcobrar/changeestatus',
                formData
            ).then( (res) => {
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=1;
                $('#UploadObservacion').modal('hide');
                this.bus.$emit('List');
                //this.$toast.success('Información Actualizada');
            }).catch( err => {
                //this.$toast.error('La infromación no pudo actualizarse');
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;
            });
               
        },
		ChangeRestante(){
			let Diferencia=parseFloat(this.RestanteOriginal)-parseFloat(this.ctaporcobrar.Monto);
			if (Diferencia<0) {
				this.ctaporcobrar.Monto='';
				this.ctaporcobrar.Restante=this.RestanteOriginal;
				this.$toast.warning('El Monto No Puede Exceder la Cantidad Restante');
			}
			else{
				this.ctaporcobrar.Restante=Diferencia;
			}
		},
		SetMonto(){
			if (this.ctaporcobrar.TipoCobro=='1') {
				this.DisableMonto=true;
				this.ctaporcobrar.Monto=this.ctaporcobrar.MontoTotal;
				this.ctaporcobrar.Restante=0;
			}
			else{
				this.DisableMonto=false;
				this.ctaporcobrar.Monto=0;
				this.ctaporcobrar.Restante=this.RestanteOriginal;
			}
		},
        get_one()
        {
          
            this.$http.get(
               "ctaporcobrar/recovery",
                {
                    params:{IdCtaCobrar: this.ctaporcobrar.IdCtaCobrar}
                }
            ).then( (res) => {
            
            this.ctaporcobrar=res.data.data.ctaporcobrar;
            //console.log(this.ctaporcobrar);
                if(this.ctaporcobrar.Estatus=='SI'){
                    this.bus.$off('Save',()=>
                    {
                        //this.Cobrado();
                    });
            }else if(this.ctaporcobrar.Estatus=='NO'){
                this.bus.$on('Save',()=>
                {
                    
                    this.Cobrado();
                });
            }
           /*
            this.ctaporpagar.FechaFactura = new Date(dos);
            */
            });
        },

		Recuperar(){
			this.$http.get('ctaporcobrarpago/recovery',{
				params:{
					IdCtaCobrar:this.ctaporcobrar.IdCtaCobrar
				}
			}).then((res) => {
				let Pagado=0;
				let Pagos=res.data.data.pagos;
				if (Pagos.length>0) {
					this.IndexFecha=Pagos.length;
					for (let i = 0; i < Pagos.length; i++) {
						let FechaFormato=Pagos[i].Fecha.replace(/-/g, "\/");
						this.ctaporcobrar.Pagos[i].Fecha=new Date(FechaFormato);
						Pagado+=parseFloat(Pagos[i].Monto);
					}
				}
				this.ctaporcobrar.Pagos[this.IndexFecha].Fecha=new Date();
				this.RestanteOriginal=Number(this.ctaporcobrar.MontoTotal)-Pagado;
				this.ctaporcobrar.Restante=Number(this.ctaporcobrar.MontoTotal)-Pagado;
				if (this.ctaporcobrar.TipoCobro=='1') {
					this.SetMonto();
				}
				if (this.ctaporcobrar.TipoCobro=='2') {
					this.DisableSelect=true;
				}
			})
		},

    	Limpiar(){
			this.ctaporcobrar={
				IdCtaCobrar:0,
        	    IdFactura:0,
        	    IdServicio:0,
        	    NumContrato:'',
        	    Archivo:'',
        	    Estatus:'',
        	    FechaRealCobro:'',
				Factura:'',
				TipoCobro:'',
				MontoTotal:'',
				Monto:'',
				Restante:'',
				Pagos:[
					{Fecha:'',Monto:''},
					{Fecha:'',Monto:''},
					{Fecha:'',Monto:''},
					{Fecha:'',Monto:''}
				]
			}
			this.IndexFecha=0;
        	this.errorvalidacion=[];
			this.DisableMonto=false;
			this.DisableSelect=false;
    	}
       
   	},

    created() {

       

      this.bus.$off('UploadO');
      this.bus.$on('UploadO',(Id, IdServ, NumContra,FechaRealCobro,IdFactura,Factura,Monto,Observacion,TipoCobro)=> 
      {
        this.Limpiar();
        this.ctaporcobrar.IdServicio=IdServ;
		this.ctaporcobrar.Factura=Factura;
		this.ctaporcobrar.MontoTotal=Monto;
		this.ctaporcobrar.Observacion=Observacion;
		this.ctaporcobrar.TipoCobro=TipoCobro=='0' ? '' : TipoCobro;
        this.FechaRealCobro=FechaRealCobro;
		// console.log(this.ctaporcobrar.Factura);
        //this.IdContrato=IdContra;
        this.NumContrato=NumContra;
        this.poBtnSave.disableBtn=false;  
        this.bus.$off('Save');
        this.bus.$on('Save',()=>
        {
          this.Cobrado();
        });

       

        if (Id>0)
        {
            this.ctaporcobrar.IdCtaCobrar=Id;
			this.Recuperar();
            // this.get_one();
           
        }
            this.bus.$emit('Desbloqueo',false);
       

      });
     

    },
}
</script>
